__webpack_require__.p = "/cosmic-tales/";